import { CommonStatsContractsType, IStatsContractsDays, IStatsContractsMonth, IStatsContractsYear } from "@api/dashboard/state.types"
import { IContractsStatusesList } from "@api/dict/state.types"
import { IUseValue } from "@hooks/useValue"

export type TWidgetContractsSource = 'modskill' | 'yaskill'

export interface IWidgetContractsStatusColors {
    signing: string
    education: string
    completed: string
    cancel: string
}

export const DEFAULT_WIDGET_CONTRACT_STATUS_COLORS: IWidgetContractsStatusColors = {
    signing: '#5B8CFF',
    education: '#FFC44C',
    completed: '#3DBA5D',
    cancel: '#FF6565',
}

/** Свойства контейнера - Статистика договоров Chart */
export interface IWidgetContractsChartActions {
    getMonthName: (monthNumber: number) => string
    source: TWidgetContractsSource
    title: string
}

/** Свойства UI - Статистика договоров Chart */
export interface IWidgetContractsChartUI {
    txtCurrentYear: IUseValue<string>
    txtCurrentMonth: IUseValue<string>
    showStatisticsData: IUseValue<boolean>
    contractStatuses: IContractsStatusesList[]
    contractStatusColors: IWidgetContractsStatusColors

    totalsYears: CommonStatsContractsType | undefined
    totalsDays: CommonStatsContractsType | undefined

    typeStats: IUseValue<"day" | "month" | "year">
    yearDetailStatsContracts: IUseValue<string>
    monthDetailStatsContracts: IUseValue<string>

    itemsYear: [] | IStatsContractsYear[]
    itemsMonth: [] | IStatsContractsMonth[]
    itemsDays: [] | IStatsContractsDays[]

    getMonthName: (monthNumber: number) => string
    title: string
}
